import { useRecoilValue } from "recoil";
import { questionsAtom } from "../miscellaneous/questionsAtom";

export const useTaskQuestionsValue = () => {
  return useRecoilValue(questionsAtom);
};
